<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">401</h1>
            <h4 class="pt-3">Odmowa dostępu</h4>
            <p class="text-muted">Brak odpowiednich uprawnień do otwarcia tej strony</p>
            <router-link :to="prevRoutePath">Powrót</router-link>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'p-Page401',
  data () {
    return {
      prevRoutePath: '/'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoutePath = from.path
    })
  }
}
</script>
